import MentionsContainer from "./MainContainer";


function MentionsPage(){
    return(
        <MentionsContainer />
    )
}

export default MentionsPage
